import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BaseDto } from '@zaoblako/shared/common/dtos/base.dto';
import { BasisSystem1cService } from '@zaoblako/web/core/services/basis/basis-system-1c.service';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { FileUploaderComponent } from '@zaoblako/web/shared/components/file-uploader/file-uploader.component';
import { FormType } from '@zaoblako/web/shared/components/form-sidebar/models/form-state';
import { FormStoreService } from '@zaoblako/web/shared/components/form-sidebar/services/form-store.service';
import { BaseFormComponent } from '@zaoblako/web/shared/dumbs/base-form/base-form.component';
import { EditorComponent } from '@zaoblako/web/shared/dumbs/editor/editor.component';
import { InputTextComponent } from '@zaoblako/web/shared/dumbs/input-text/input-text.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import { Expose } from 'class-transformer';
import { IsDefined, IsString } from 'class-validator';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { Observable } from 'rxjs';

@Expose()
export class Extension1CForm extends BaseDto {
  @Expose()
  @IsString({ message: 'Версия должна быть строкой' })
  @IsDefined({ message: 'Введите версию' })
  public version: string;

  @Expose()
  @IsDefined({ message: 'Выберите файл' })
  public file: FormData;

  @Expose()
  public changelog: string;
}

@Component({
  selector: 'crm-extension1c-form',
  standalone: true,
  imports: [
    CommonModule,
    InputTextComponent,
    JoinPipe,
    FileUploaderComponent,
    CardModule,
    ButtonModule,
    EditorComponent,
    SpinnerComponent
  ],
  templateUrl: './extension1c-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Extension1cFormComponent extends BaseFormComponent<Extension1CForm> implements OnInit {
  @Input() public readonly index: number;
  public form = new Extension1CForm();
  public dto = Extension1CForm;
  public form$: Observable<FormType>;
  public loading$: Observable<boolean>;

  public fileInfo: File;

  public constructor(
    private readonly basisSystem1cService: BasisSystem1cService,
    public readonly formStoreService: FormStoreService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly errorService: ErrorService
  ) {
    super();
  }

  public ngOnInit() {
    this.form$ = this.formStoreService.select((state) => state.forms[this.index]);
    this.loading$ = this.formStoreService.select((state) => state.forms[this.index]?.loading);

    if (!this.formStoreService.getState.forms[this.index]?.isEdit) {
      this.basisSystem1cService.getLatest().subscribe((plugin) => {
        if (plugin) {
          const lastNumber = +plugin.version?.split('.')[2] + 1;
          this.form.version = `${plugin.version?.split('.')[0]}.${plugin.version?.split('.')[1]}.${lastNumber}`;
          this.form = { ...this.form };
          this.cdRef.markForCheck();
        }
      });
    }
  }

  public saveExtension() {
    if (this.form.changelog) {
      this.form.file.append('changelog', this.form.changelog);
    }

    if (this.checkValidate(this.form).valid) {
      this.formStoreService.setLoading(true, this.index);

      this.basisSystem1cService.setVersion(this.form).subscribe({
        next: () => {
          this.formStoreService.setLoading(false, this.index);
          this.errorService.addSuccessMessage('Версия расширения создана');
          this.formStoreService.saveNext(null, this.index);
        },
        error: () => {
          this.formStoreService.setLoading(false, this.index);
        }
      });
    }
  }

  public uploadFile(files: FileList) {
    const formData = new FormData();
    formData.append('file', files[0]);

    this.fileInfo = files[0];
    this.form.file = formData;
  }
}
